// libraries.
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

// endpoints.
import { useLazyGetRulesQuery } from "./rules.endpoints";

// slices.
import { setRulesForCountry } from "./slices/rules/rulesSlice";

const SCHEMA_BY_COUNTRY: Record<string, "inventory_co" | "inventory_mx"> = {
  CO: "inventory_co",
  MX: "inventory_mx",
};

export const useGetRules = (country: string) => {
  const dispatch = useDispatch();
  const [triggerGetRules, { data, isLoading, isError, isFetching, isSuccess }] =
    useLazyGetRulesQuery();

  useEffect(() => {
    const schema = SCHEMA_BY_COUNTRY[country];
    if (!schema) return;

    triggerGetRules({ schema });
  }, [country, triggerGetRules]);

  useEffect(() => {
    if (isSuccess && data?.data) {
      dispatch(
        setRulesForCountry({
          country,
          exceptions: data.data.exceptions,
          steps: data.data.steps,
          rawRules: data.data.rawRules,
        }),
      );
    }
  }, [isSuccess, data, country, dispatch]);

  useEffect(() => {
    if (isError) {
      toast.error("Error al cargar las reglas de incentivos");
    }
  }, [isError]);

  return { isFetching, isLoading };
};
